import { ColorTextMedium, ColorGreen500, ColorRed500 } from "@nxt-costco-com/forge-design-tokens";
const commonSx = {
  textWrap: "wrap",
  color: ColorTextMedium
};
const OpenSx = {
  ...commonSx,
  color: ColorGreen500
};
const ClosedSx = {
  ...commonSx,
  color: ColorRed500
};
export {
  ClosedSx,
  OpenSx,
  commonSx
};
